module.exports = {"id":"220523","name":"Yerry Mina","rating":"80","photo":"./data/images/photos/0/220523.png","club":{"name":"FC Barcelone","logo":"./data/images/clubs/FCBarcelone.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YerryMina0.json
// module id = 4405
// module chunks = 0